import type { PropsWithChildren } from 'react'

import type { ShipperUserRole, UserPermissionType } from '@fv/models'

import { HasPermission } from './HasPermission'
import { useRole } from './hooks'

type Props = PropsWithChildren<{
  role: ShipperUserRole
}>
export const HasRole = (props: Props) => {
  const role = useRole()
  if (role !== props.role) return null

  return props.children
}

export const HideForVendor = ({ children }: PropsWithChildren) => (
  <HasRole role="shipper">{children}</HasRole>
)

type ShipperOnlyProps = PropsWithChildren & {
  permissions: UserPermissionType[]
}
export const ShipperOnly = ({ children, permissions }: ShipperOnlyProps) => (
  <HasRole role="shipper">
    <HasPermission oneOf={permissions}>{children}</HasPermission>
  </HasRole>
)
